"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.voice.id': 'Voice ID',
};
